import { useEffect, useState } from 'react';
import { useDebounce } from 'react-use-v13';
import { twMerge } from 'tailwind-merge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMagicSearch, useMagicSearchContext } from '../MagicSearchContext';
import { Icon } from '@scale/scaleui';

type DebouncedSearchFieldProps = {
  className?: string;
};

export const DebouncedSearchField = ({ className }: DebouncedSearchFieldProps) => {
  const { searchStore, plugins } = useMagicSearchContext();
  const {
    state: { searchText, searchScopes },
    onUpdateState,
  } = useMagicSearch(s => ({
    state: s.state,
    onUpdateState: s.onUpdateState,
  }));

  const [localSearchText, setLocalSearchText] = useState(searchText);
  useEffect(() => {
    setLocalSearchText(searchText);
  }, [searchText]);

  useDebounce(
    () =>
      onUpdateState({
        searchText: localSearchText,
      }),
    300,
    [localSearchText],
  );

  return (
    <div className={twMerge('flex gap-2 h-11 hover:bg-neutral-100', className)}>
      <div className="h-full flex items-center pl-3">
        <FontAwesomeIcon className={twMerge('w-6 h-6 text-neutral-600')} icon={['far', 'search']} />
      </div>
      {/* We are hiding this component to not show the scope pills in the search bars since seems to be confusing.
          I think We should revisit this to find a better ui/ux and still show the scopes. PR url to check changes: https://github.com/scaleapi/scaleapi/pull/110554
          in case we want to restore the component
      */}
      {/* {searchScopes?.map(searchScope => (
        <SearchScopeItem
          key={searchScope.id}
          scope={searchScope}
          onRemove={() => onRemoveSearchScope(searchScope.id)}
        />
      ))} */}
      <input
        autoFocus
        className={twMerge(
          'flex-1 h-full text-neutral-800 bg-transparent placeholder:text-neutral-400 caret-primary-400 border-none focus:border-none focus:ring-0 px-0',
        )}
        type="text"
        value={localSearchText}
        onChange={e => {
          setLocalSearchText(e.target.value);
        }}
        placeholder={`Search for ${plugins
          .map(plugin => plugin.hint?.({ searchText, searchScopes }))
          .filter(Boolean)
          .join(', ')}`}
      />
      <div className="h-full flex items-center pr-3">
        <Icon
          className={twMerge('-mr-1')}
          icon={['far', 'times']}
          rounded
          variant="neutral"
          size="lg"
          onClick={() => {
            searchStore?.getState().onResetStore();
          }}
        />
      </div>
    </div>
  );
};
